interface HighlightString {
  children: string;
}

/**
 * Renders a plain string or if it contains HTML tags for highlights (`<em>`),
 * parses it and renders with the highlighted value.
 */
export function HighlightString({ children }: HighlightString) {
  const rawString = highlightHtmlStringToString(children);

  // string contains no highlights
  if (rawString === children) {
    return children;
  }

  const segments = children.split(/<em>|<\/em>/);

  return (
    <span className="whitespace-pre-wrap">
      {segments.map((segment, index) => {
        // Highlight strings are guaranteed to alternate between non-highlighted (even) and highlighted (odd) segments.
        if (index % 2 === 0) {
          return <span key={index}>{segment}</span>;
        }

        // Apply formatting to the highlighted segments.
        return (
          <span key={index} className="bg-yellow-100">
            {segment}
          </span>
        );
      })}
    </span>
  );
}

/**
 * Converts a highlight HTML string into a raw string without any emphasis tags.
 * @example
 * 'foo <em>bar</em> baz' -> 'foo bar baz'
 */
export const highlightHtmlStringToString = (highlight: string): string =>
  highlight.split(/<em>|<\/em>/).join('');
